// cache keys
const lit = <V extends keyof any>(v: V) => v

export const CACHE_KEYS = {
  TASKS: lit('tasks'),
} as const

export enum TaskTypeEnum {
  PHOTO = 'PHOTO',
  TOGGLE = 'TOGGLE',
  SIGN = 'SIGN',
  TEXT = 'TEXT',
  DOCUSIGN = 'DOCUSIGN',
  OPTION = 'OPTION',
  MULTIPLE_OPTION = 'MULTIPLE_OPTION',
  EMAIL = 'EMAIL',
  CALENDAR_EVENT = 'CALENDAR_EVENT',
  UPLOAD_MEDIA = 'UPLOAD_MEDIA',
  INFO = 'INFO',
  QUIZ = 'QUIZ',
  SURVEY = 'SURVEY',
  SLACK_MESSAGE = 'SLACK_MESSAGE',
  SEND_SAFELY = 'SEND_SAFELY',
  SMS = 'SMS',
  VIDEO = 'VIDEO',
  AUDIO = 'AUDIO',
  DOCEBO = 'DOCEBO',
  SCORM_COURSE = 'SCORM_COURSE',
  SCORECARD = 'SCORECARD',
  AI_ROLEPLAY = 'AI_ROLEPLAY',
}

export enum TaskTypeEnum {
  COLD_CALL = 'COLD_CALL',
  WARM_CALL = 'WARM_CALL',
  DISCOVERY_MEETING = 'DISCOVERY_MEETING',
  DEMO_MEETING = 'DEMO_MEETING',
  NEGOTIATION = 'NEGOTIATION',
  OTHER = 'OTHER',
}

export enum CalendarEventTypes {
  NEW_EVENT = 'NEW_EVENT',
  EXISTING_EVENT = 'EXISTING_EVENT',
  GROUP_EVENT = 'GROUP_EVENT',
  // ENGG-9885: the employee picks one session of other group-event tasks
  SESSION_PICKER = 'SESSION_PICKER',
}

export enum RoleplayTypeEnum {
  CUSTOMER_CONVERSATION = 'CUSTOMER_CONVERSATION',
  SCREENSHARE_WALKTHROUGH = 'SCREENSHARE_WALKTHROUGH',
  CUSTOMER_CONVERSATION_WITH_SCREENSHARE = 'CUSTOMER_CONVERSATION_WITH_SCREENSHARE',
}

export enum TaskStateEnum {
  COMPLETE = 'COMPLETE',
  CANT_COMPLETE = 'CANT_COMPLETE',
  TODO = 'TODO',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum TaskFrequencyEnum {
  RECURRING = 'RECURRING',
  ONE_TIME = 'ONE_TIME',
}

export enum SnippetTypeEnum {
  STATIC = 'STATIC',
  DYNAMIC = 'DYNAMIC',
  DYNAMIC_EMAIL = 'DYNAMIC_EMAIL',
  CONDITIONAL = 'CONDITIONAL',
}

// Snippets that render an HTML list, so they must not be inserted into a
// plain-text title (email subject, Slack channel name, calendar title). Kept in
// sync with the backend's HTML_ONLY_EMPLOYEE_SNIPPET_NAMES (ENGG-8910).
export const HTML_ONLY_SNIPPET_NAMES = [
  'employee.outstanding_tasks_list',
  'employee.overdue_tasks_list',
]

// Snippets resolved from the task being rendered. Outside a task — cohort
// emails, communication schedules, certificate and settings emails, report
// schedules — the backend has no task to read and renders the fallback text, so
// these are hidden from those pickers. Opt in with SnippetsList's `taskScoped`
// (ENGG-9596).
export const TASK_SCOPED_SNIPPET_NAMES = ['task.due_date']

export enum DefaultDateTypeNames {
  START_DATE = 'Start Date',
  TERMINATION_DATE = 'Termination Date',
  WORKFLOW_ASSIGNED_DATE = 'Workflow Assigned Date',
  TASK_ASSIGNED_DATE = 'Task Assigned Date',
}

export enum SlackEventType {
  SEND_MESSAGE = 'SEND_MESSAGE',
  CHANNEL_INVITE = 'CHANNEL_INVITE',
  GROUP_INVITE = 'GROUP_INVITE',
  SEND_MESSAGE_TO_CHANNELS = 'SEND_MESSAGE_TO_CHANNELS',
  KICK_FROM_CHANNEL = 'KICK_FROM_CHANNEL',
}

export enum ConnectionStatus {
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
  NOT_FOUND = 'NOT_FOUND',
  REVOKED = 'REVOKED',
}
